const data = [
    {
        src: '/riverbank_main.jpg',
        alt: 'Riverbank school show',
        description:'Riverbank school, Cardiff',
    },
    {
        src: '/riverbank_multi.jpg',
        alt: 'Riverbank school interactions',
        description:'Riverbank school, Cardiff',
    },
    {
        src: '/folk1.jpeg',
        alt: 'La Sonora Boreal at Allen Valleys Folk Festival',
        description:'La Sonora Boreal at Allen Valleys Folk Festival',
    },
    {
        src: '/folk2.jpeg',
        alt: 'La Sonora Boreal at Lindisfarne festival',
        description:'La Sonora Boreal at Lindisfarne festival',
    },
    
    {
        src: '/choir.jpeg',
        alt: 'Multilingual Choir at Whitley Bay festival',
        description:'Multilingual Choir at Whitley Bay festival',
    }



];


export default data
